import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {WhiteListsFilter, WhiteListsState} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<WhiteListsState, RootState> = {
    getWhiteLists: ({ commit }, data: WhiteListsFilter) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/whitelist/recipients`, params: data})
                .then((resp: any) => {
                    if (data?.page_number > 1) {
                        commit("pushWhiteLists", resp.data?.recipients);
                    } else {
                        commit("setWhiteLists", resp.data?.recipients);
                    }
                    resolve(resp.data?.recipients)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getWhiteListsItem: ({commit, dispatch}, id: number) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/whitelist/recipients/${id}`})
                .then((resp: any) => {
                    commit('setWhiteListItem', resp.data);
                    resolve(resp.data)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    saveWhiteList: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: data.id ? 'put' : 'post',
                url: `/acapi/whitelist/recipients/${data.id ?? ''}`,
                data: data.item
            })
                .then((resp: any) => {
                    dispatch('getWhiteLists');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    deleteWhiteList: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/whitelist/recipients/${data.id}`,
                data: {
                    id: data.id
                }
            })
                .then((resp: any) => {
                    dispatch('getWhiteLists');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    deleteWhiteLists: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/whitelist/recipients`,
                data: {
                    recipient_ids: data.recipientIds
                }
            })
                .then((resp: any) => {
                    dispatch('getWhiteLists');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    exportWhiteLists: ({}) => {
        return directDownload('/acapi/whitelist/recipients/export')
    },
    importWhiteLists: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise(async (resolve, reject) => {
            axios({
                method: 'post',
                url: `/acapi/whitelist/recipients/import`,
                data: data.item
            })
                .then((resp: any) => {
                    dispatch('getWhiteLists');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
};
